(function () {
  class AnticipationRule extends SlotsEngine.instantiators.SymbolRule {
    constructor() {
      super();
    }

    initialise(json) {
      let groupings = {};
      for (let i = 0; i < json.rules.length; ++i) {
        groupings = Object.assign(groupings, json.rules[i]);
      }
      this._weightings = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1000, 100,
      ];
      this._totalWeightings = this._weightings.reduce(function (
        accumulator,
        currentValue
      ) {
        return accumulator + currentValue;
      });
      super.initialise(groupings);
    }

    isSymbolValid(symbolId, previousWindowSymbols, nextSymbol) {
      if (symbolId === previousWindowSymbols[previousWindowSymbols.length - 1])
        // cant continue the group from previous group
        return false;
      else if (symbolId === nextSymbol) return false;
      else if (!this.doesSymbolHaveRule(symbolId))
        // if there is no rule then it is fine
        return true;

      return true;
    }

    getNumSymbolsToReserve(symbolId) {
      if (gameController.anticipating) {
        const reelVisual = resourceManager.get(
          "slotContainer:reelContainer:reel" + this.Props.reelId
        );
        if (!reelVisual.spawnedAnticipationSymbol) {
          reelVisual.spawnedAnticipationSymbol = true;
          return 1;
        }
      }
      return 0;
    }

    getReservedSymbols(symbol, num) {
      return [54];
    }

    getAdditionalSymbolsNeededToSatisfyRule(symbolsInView) {
      let res = [];
      let lastSymbol = symbolsInView[symbolsInView.length - 1];

      let count = 0;
      for (let i = symbolsInView.length - 1; i >= 0; --i) {
        if (this.doesSymbolHaveRule(symbolsInView[i])) {
          ++count;
        } else {
          break;
        }
      }
      if (count > 0) {
        let numExtraNeeded = Math.max(
          this.getNumSymbolsNeeded(lastSymbol) - count,
          0
        );
        res = this.getReservedSymbols(lastSymbol, numExtraNeeded);
      }
      return res;
    }
  }
  resourceManager.registerController("SymbolRules_anticipation", function () {
    return new AnticipationRule();
  });
})();
